import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GuestNoteType } from './guest-note-types.model';

export interface GuestNoteTypeState extends EntityState<GuestNoteType, string> {}

@StoreConfig({ name: 'GuestNoteType', resettable: true })
export class GuestNoteTypeStore extends EntityStore<GuestNoteTypeState> {}

export const guestNoteTypeStore = new GuestNoteTypeStore();
